export default {
    url: 'app',
    include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'cis', 'eu'],
};
